import { Map, Record } from 'immutable';

export function combineReducersMap<S, RS extends Map<string, any>>(
  reducers: { [K in keyof S]: (state: S[K], action: IAction<any, any>) => S[K] },
  initialState: RS
): (state: RS, action: IAction<any, any>) => RS {
  const reducersRecord = Record(reducers)().toSeq();
  return (inputState: RS, action: IAction<any, any>): RS => {
    return inputState.withMutations(temporaryState => {
      reducersRecord.forEach((reducer, reducerName) => {
        const currentDomainState = temporaryState.get(reducerName as string);
        const nextDomainState = reducer(currentDomainState, action);
        temporaryState.set(reducerName as string, nextDomainState);
      });
    });
  };
}
